import { CarruselImages } from "./carrusel-images";

export const CarruselImagesContainer = ({ title, images }) => {
  return (
    <div className="carrusel-images-container">
      <div className="title">
        <p>{title}</p>
      </div>
      <div>
        <CarruselImages images={images}></CarruselImages>
      </div>
    </div>
  );
};
